import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'craig-user-message',
    templateUrl: './user-message.component.html',
    styleUrl: './user-message.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMessageComponent {
    @Input() message: string = '';
}
